import { get } from "./utils";
import { Course } from "../models/statuspage/course";
import { CourseEnrollment } from "../models/statuspage/course-enrollment";

export const getCourses = async () => await get<Course[]>("courses", true);
export const getCourseEnrollments = async () => await get<CourseEnrollment[]>("courses/enrollments/currentuser");
export const getActiveCourseEnrollments = async () => await get<CourseEnrollment[]>("courses/enrollments/currentuser/active", true);
